import * as R from 'ramda'
import Globals from '../../globals/index'
import { dateComparator } from '../../../util/datetime'
import { renderStateName } from '../../process/util/names'


export const enrichSalesOrderList = (state, salesOrderList) => {
    R.forEach(salesOrder => {
        enrichSalesOrder(state, salesOrder)
    }, salesOrderList)
}

export const enrichSalesOrder = (state, salesOrder) => {
    salesOrder.isSet = salesOrder.type === 'set'
    const statusResolver = salesOrder.isSet ? Globals.selector.selectSalesOrderStatusValueById : Globals.selector.selectSalesOrderTreatmentStatusValueById
    //
    salesOrder.statusName = statusResolver(state, salesOrder.status) || renderStateName(salesOrder.status)
    salesOrder.responsibleEmployeeName = Globals.selector.selectEmployeeNameById(state, salesOrder.responsibleEmployeeId)

    R.forEach(statusHistory => {
        statusHistory.statusName = statusResolver(state, statusHistory.newStatus)
        statusHistory.changedByEmployeeName = Globals.selector.selectEmployeeNameById(state, statusHistory.changeByEmployeeId)
    }, salesOrder.statusHistory)
    salesOrder.statusHistory.sort(dateComparator('changed'))
}



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/enrich-sales-order.js